import { render, staticRenderFns } from "./EmailDeliveryQueueView.vue?vue&type=template&id=02b3fbc2"
import script from "./EmailDeliveryQueueView.vue?vue&type=script&lang=js"
export * from "./EmailDeliveryQueueView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports